<div style="width: 100% !important; max-width: 100%;">

  <!-- Loading -->
  <div *ngIf="sugestionByDestination.length === 0 && !noData" class="search-status-container" role="status" aria-live="polite" aria-busy="true">
    <div class="search-animation">
      <div class="search-spinner"></div>
    </div>
    <p class="search-message">
      Estamos buscando sugerencias para
      <strong>{{ actualItinerary?.destination[0]?.destination_info?.cityName || "tu destino" }}</strong>
    </p>
    <p class="search-tip text-muted">Esto puede tomar unos segundos. Mientras tanto, puedes seguir explorando.</p>
  </div>

  <!-- No data -->
  <div *ngIf="noData" class="no-results-container" role="alert" aria-live="polite">
    <h3 class="no-results-title">No se encontraron sugerencias</h3>
    <p class="no-results-message">
      No hemos encontrado sugerencias disponibles para
      <strong>{{ actualItinerary?.destination[0]?.destination_info?.cityName || "tu destino" }}</strong>.
    </p>
    <p class="no-results-tip text-muted">Intenta modificar tus criterios de búsqueda o consulta nuevamente más tarde.</p>
  </div>

  <!-- One carousel at the top level; each slide is one destination. -->
  <!-- Carousel por destinos — scroll horizontal con dots y autoplay -->
  <div *ngIf="sugestionByDestination.length > 0"
       class="native-carousel position-relative py-3"
       style="position: relative; width: 100%; max-width: 100%; min-width: 0; overflow: hidden; box-sizing: border-box; contain: layout;"
       (mouseenter)="isHovered = true"
       (mouseleave)="isHovered = false">

    <div style="position: relative; min-width: 0; max-width: 100%; box-sizing: border-box;">

      <div #carouselViewport
           class="native-carousel-viewport"
           (scroll)="onCarouselScroll($event)"
           style="overflow-x: auto; overflow-y: hidden; min-height: 320px; width: 100%; max-width: 100%; min-width: 0; scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch; scroll-behavior: smooth; box-sizing: border-box;">

        <div class="native-carousel-track" style="display: inline-flex; flex-wrap: nowrap;">

          <ng-container *ngFor="let group of sugestionByDestination; let i = index">
            <div class="native-carousel-slide d-flex flex-column"
                 style="flex: 0 0 100%; width: 100%; max-width: 400px; min-width: 0; box-sizing: border-box; scroll-snap-align: start; scroll-snap-stop: always; display: flex;">

              <!-- Imperdible card — byte-for-byte same markup as original, bound to group.important -->
              <div *ngIf="group.important" class="w-100 mb-3" id="visited-component">
                <div class="w-100">
                  <div class="p-3" style="background-color: #ffffff; border-radius: 12px">
                    <h3 class="mb-3" style="font-size: 20px; font-weight: 600; font-family: &quot;Muli&quot;, sans-serif">Imperdible</h3>

                    <div class="mb-3" style="height: 250px; max-width: 100%; overflow: hidden; position: relative;">
                      <img
                        *ngIf="group.important?.additionalInfo?.images?.[0]?.thumbnail !== null"
                        src="{{ group.important?.additionalInfo?.images?.[0]?.thumbnail }}"
                        style="width: 100%; height: 100%; max-width: 100%; object-fit: cover; display: block;"
                        alt=""
                      />

                      <!-- DOTS -->
                      <div *ngIf="sugestionByDestination.length > 1" class="d-flex align-items-center" style="position: absolute; bottom: 15px; right: 15px;">
                        <div
                          *ngFor="let group of sugestionByDestination; let i = index"
                          (click)="goToSlide(i); pauseAutoplayForUserInteraction();"
                          class="d-flex align-items-center mr-1"
                          style="font-family: 'Rubik'; font-size: 12.79px; font-weight: 400; color: #FFFFFF; line-height: 1.2; gap: 5px; cursor: pointer;"
                        >
                          {{ i + 1 }} >
                          <span *ngIf="i !== sugestionByDestination.length - 1" style="display: inline-block; width: 35px; height: 1px; background-color: #FFFFFF;"></span>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex flex-column">
                        <span
                          style="font-size: 12px; font-weight: 400; text-transform: normal; line-height: 1; font-family: &quot;Muli&quot;, sans-serif"
                          >Desde</span
                        >
                        <h3
                          [ngStyle]="{ 'font-size': computePrice(group.important) | dynamicFontSize: 18 : fontSizeAdjustments }"
                          style="font-weight: 600; text-transform: normal; line-height: 1; font-family: &quot;Muli&quot;, sans-serif"
                        >
                          {{ currencyAgency?.code }} {{ computePrice(group.important) | number: "1.2-2" }}
                        </h3>
                      </div>

                      <button
                        (click)="openModal(modalTours, 'tour', 'imperdible', null)"
                        class="btn btn-select"
                        [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                      >
                        Seleccionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Esencial — vertical list inside the slide (NOT a carousel) -->
              <div *ngIf="group.essencial && group.essencial.length > 0" style="background-color: #ffffff; border-radius: 12px" class="p-3">
                <h3 class="mb-2" style="font-size: 20px; font-weight: 600; font-family: 'Muli', sans-serif">Escencial</h3>
                <div class="d-flex flex-column">
                  <ng-container *ngFor="let essencial of group.essencial; let index = index">
                    <!-- Inner card markup — byte-for-byte same as original essencial-card -->
                    <div
                      class="w-100 p-3 mb-2 essencial-card"
                      style="overflow: hidden; max-width: 100%;"
                      [ngStyle]="{ 'background-image': essencial?.additionalInfo?.images?.[0]?.thumbnail ? 'url(\'' + essencial?.additionalInfo?.images?.[0]?.thumbnail + '\')' : null }"
                      role="img"
                      [attr.aria-label]="essencial?.title || 'imagen'"
                    >
                      <div
                        style="
                          position: absolute;
                          left: 0;
                          top: 0;
                          background: linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
                          width: 100%;
                          height: 100%;
                          z-index: 10;
                        "
                      ></div>

                      <div class="row h-100" style="position: relative; z-index: 20">
                        <div class="col-7 h-100">
                          <div class="h-100 d-flex flex-column align-items-start justify-content-between">
                            <span class="essencial-tag">Popular</span>

                            <div>
                              <h4 class="essencial-title">
                                {{ essencial?.title }}
                              </h4>
                              <p class="essencial-description m-0">{{ essencial?.additionalInfo?.tours?.options?.[0]?.option_name }}</p>
                            </div>
                          </div>
                        </div>

                        <div class="col-5 pl-0 h-100">
                          <div class="h-100 d-flex flex-column align-items-end justify-content-between">
                            <div
                              class="essencial-tag"
                              style="width: 100%; padding: 5px 0px; padding-left: 15px; border-radius: 10px; border: 3px solid"
                              [ngStyle]="{ 'border-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                            >
                              <span style="font-size: 10px; font-weight: 400">Desde</span>

                              <p
                                class="d-flex flex-column align-items-start m-0"
                                [ngStyle]="{ 'font-size': computePrice(essencial) | dynamicFontSize: 14 : fontSizeAdjustments }"
                                style="font-weight: 700; font-family: &quot;Muli&quot;, sans-serif"
                              >
                                <span style="line-height: 1">{{ currencyAgency?.code }}</span>
                                <span style="line-height: 1.1">
                                  {{ computePrice(essencial) | number: "1.2-2" }}
                                </span>
                              </p>
                            </div>

                            <button
                              class="btn btn-select w-100"
                              [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                              style="font-size: 11px; padding: 5px 20px"
                              (click)="openModal(modalTours, 'tour', 'essencial', essencial.flatIndex)"
                            >
                              Seleccionar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

            </div>
          </ng-container>

        </div>
      </div>

    </div>
  </div>

</div>
